var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form-inline",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.selectRegion.apply(null, arguments)
        },
      },
    },
    [
      _c("vue-bootstrap-typeahead", {
        attrs: {
          data: _vm.search_results,
          serializer: function (s) {
            return s.term
          },
          "min-matching-chars": 3,
          placeholder: "chr:start-end, rs, or gene",
        },
        model: {
          value: _vm.region,
          callback: function ($$v) {
            _vm.region = $$v
          },
          expression: "region",
        },
      }),
      _vm._v(" "),
      _c("input", {
        staticClass: "btn btn-primary",
        attrs: { type: "submit", value: "Go to region" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }